<template>
<div class="swaychat-end-chat">
  <simple-rating v-if="(getSettings.rating === true || getSettings.rating === 1) && !getSession.rated_at"></simple-rating>
  <advance-rating v-if="(getSettings.rating === 2)"></advance-rating>
  <next-chat v-if="!getSettings.rating || getSession.rated_at"></next-chat>
</div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import SimpleRating from './SimpleRating.vue'
import NextChat from './NextChat.vue'
import AdvanceRating from './AdvanceRating.vue'

export default {
  components: {
    SimpleRating,
    NextChat,
    AdvanceRating
  },
  computed: {
    ...mapGetters([
      'getSettings',
      'getSession'
    ])
  }
}
</script>
